import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { getParentSibling, getNextSibling } from '../scripts/accessibility';
var MenuButton = function MenuButton(_ref) {
  var click = _ref.click,
    locale = _ref.locale,
    navSideOpen = _ref.navSideOpen,
    text = _ref.text;
  var menuButtonEl = useRef(null);
  var hamburgerAria = locale === 'es' ? "".concat(navSideOpen ? 'Cerrar' : 'Expandir', " men\xFA") : "".concat(navSideOpen ? 'Close' : 'Open', " menu");
  var handleClick = function handleClick() {
    click();
  };
  var handleKeyDown = function handleKeyDown(event) {
    var keyCode = event.keyCode;
    var downArrow = 40;
    var tab = 9;
    var enter = 13;
    var escape = 27;
    var spaceBar = 32;
    var upArrow = 38;
    var rightArrow = 39;
    var currentDomEl = event.target;
    var focusFirstSideNavItem = function focusFirstSideNavItem() {
      document.querySelector('.header__nav-side__nav-item').focus();
    };
    if (keyCode === spaceBar || keyCode === enter || keyCode === downArrow) {
      event.preventDefault();
      if (!navSideOpen || navSideOpen && keyCode !== downArrow) {
        click();
      } else {
        focusFirstSideNavItem();
      }
    } else if (keyCode === tab && navSideOpen) {
      event.preventDefault();
      focusFirstSideNavItem();
    } else if (keyCode === upArrow && navSideOpen) {
      var subMenuItemLinks = document.querySelectorAll('.header__nav-side a');
      subMenuItemLinks[subMenuItemLinks.length - 1].focus();
    } else if (keyCode === escape) {
      if (navSideOpen) {
        click();
      }
    } else if (keyCode === rightArrow) {
      var nextElement = getNextSibling(currentDomEl, 'next') || getParentSibling(currentDomEl, 'next');
      if (nextElement) {
        nextElement.focus();
      }
    }
  };
  return /*#__PURE__*/React.createElement("button", {
    "aria-controls": "header__nav-side",
    "aria-expanded": navSideOpen,
    "aria-label": hamburgerAria,
    className: "header__nav-top__button header__nav-top__button-menu",
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: menuButtonEl,
    type: "button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon header__nav-top__button-menu--icon"
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)), text && /*#__PURE__*/React.createElement("span", {
    className: "header__nav-top__button-text header__nav-top__button-menu--text"
  }, text));
};
export default MenuButton;
MenuButton.propTypes = {
  click: PropTypes.func,
  locale: PropTypes.string,
  navSideOpen: PropTypes.bool,
  text: PropTypes.string
};
MenuButton.defaultProps = {
  click: '',
  locale: 'en',
  navSideOpen: false,
  text: ''
};